import { createContext, useContext, useState, useEffect } from 'react';
import questionsConfig from '../config/questions.json';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  // Get initial language from localStorage or default to 'en'
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('appLanguage');
    return savedLanguage || 'en';
  });

  // Save language preference to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('appLanguage', language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prevLang => {
      if (prevLang === 'en') return 'mr';
      if (prevLang === 'mr') return 'hi';
      return 'en';
    });
  };

  const translations = questionsConfig.translations[language];

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    translations
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

